var map = {
	"./app.json": 524,
	"./blog.json": 525,
	"./components.json": 526,
	"./conversionTable.json": 527,
	"./currency.json": 528,
	"./currencyBRL.json": 529,
	"./currencyUSD.json": 530,
	"./cxi-old.json": 531,
	"./events.json": 532,
	"./form.json": 533,
	"./glossary.json": 534,
	"./home.json": 535,
	"./iframe.json": 536,
	"./login.json": 537,
	"./logout.json": 538,
	"./matches.json": 539,
	"./menu.json": 540,
	"./news.json": 541,
	"./notifications.json": 542,
	"./oiweek.json": 543,
	"./pages.json": 544,
	"./profile.json": 545,
	"./ranking-BKP.json": 546,
	"./ranking.json": 547,
	"./register.json": 548,
	"./startupId.json": 549,
	"./support.json": 550,
	"./translation.json": 551
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 523;